// extracted by mini-css-extract-plugin
export default {"search":"SearchBar_search__9YVhT","inputGroup":"SearchBar_inputGroup__EM1eT","icon":"SearchBar_icon__nGG8J","input":"SearchBar_input__azCSB","searchOff":"SearchBar_searchOff__du0R9"};